module.exports = __webpack_public_path__ + "static/media/slideshow-39.378920b9.jpeg";